module.exports = __webpack_public_path__ + "static/media/10.343cbe89.jpg";